(function (UX) {
    var trapFocus = function ($container) {
        var focusableElements = `button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])`;
        var $lastActiveElement = document.activeElement;
        var getFirstFocusableElement = function () {
            return $($container).find(focusableElements).filter(':visible')[0];
        };
        var getLastFocusableElement = function () {
            return [...$($container).find(focusableElements).filter(':visible')].reverse()[0];
        };
        var trapFocusController = function (e) {
            let isTabPressed = e.key === 'Tab' || e.keyCode === 9;
            if (!isTabPressed) {
                return;
            }

            if (e.shiftKey) {
                if (document.activeElement === getFirstFocusableElement()) {
                    getLastFocusableElement().focus();
                    e.preventDefault();
                }
            } else {
                if (document.activeElement === getLastFocusableElement()) {
                    getFirstFocusableElement().focus();
                    e.preventDefault();
                }
            }
        };

        var returnedControls = {
            wait: function (miliseconds) {
                var _this = this;
                return new Promise(function (resolve, reject) {
                    setTimeout(function () {
                        resolve(_this);
                    }, miliseconds || 1000);
                });
            },
            init: function ($initFocus) {
                $($container).on('keydown', trapFocusController);
                if ($initFocus.length > 0) {
                    $initFocus.focus();
                } else {
                    getFirstFocusableElement().focus();
                }
                return this;
            },
            destroy: function () {
                $($container).unbind('keydown', trapFocusController);
                this.wait(100).then(() => $lastActiveElement.focus());
            },
        };
        returnedControls.destroy.on = function (event, selector) {
            let supportedKeysAsEvents = {
                enter: 13,
            };
            event = event
                .split(' ')
                .map(event => (supportedKeysAsEvents[event] ? 'keydown' : event))
                .join(' ');
            var destroyHandler = function (e) {
                if (e.type === 'keydown' && !supportedKeysAsEvents[e.key.toLowerCase()]) return;
                returnedControls.destroy();
                $(selector).unbind(event, destroyHandler);
            };
            $(selector).on(event, destroyHandler);
        };
        return returnedControls;
    };

    UX.trapFocus = trapFocus;
})(UX);
